import _ from "lodash";
import * as React from "react";
import * as BS from "react-bootstrap";
import * as Comp from "../../../../components";
import { IComponentWithValidatedForm } from "../../../../components/validation";
import * as Forms from "../../../../forms";
import * as M from "../../../../models";
import { TinymceOptions } from "../../../../options";
import { Api } from "../../../../services/Api";
import { ReactHelper, Utility } from "../../../../utils";

interface OwnProps {
    api: Api;
    errors: string[];
    formComponent: IComponentWithValidatedForm;
    media: Forms.Abstract.AbstractMediaData;
    typeMedia: Forms.Abstract.AbstractTypeMediaData;
    namePrefix: string;
    onRemove: () => void;
}

interface OwnState {
}

export class AbstractMediaEditor extends React.Component<OwnProps, OwnState> {

    private _searchTimeout: NodeJS.Timer;

    public render() {
        const m = this.props.media;
        const tm = this.props.typeMedia;
        let mediaDisplay: JSX.Element | null = null;

        if (m.isImage && m.url)
            mediaDisplay = <p>
                {m.thumbMd
                    ? <a href={m.url} target="_blank" title="Click to view larger image"><img alt={m.fileName} src={m.thumbMd} style={{ width: "500px" }} /></a>
                    : <img alt={m.fileName} src={m.url} style={{ weight: "500px" }} />
                }
                <br />{m.fileName}
            </p>;
        else if (m.isVideo && m.isProcessing)
            mediaDisplay = <BS.Alert bsStyle="info">
                <Comp.Generic.Icon icon="check" /> Upload successful! Preview will be available after video is processed.
            </BS.Alert>;
        else if (m.isVideo && m.embedUrl)
            mediaDisplay = <Comp.Generic.WrapperLess>
                <video className="video" controls src={m.embedUrl} />
                <p>{m.fileName}</p>
            </Comp.Generic.WrapperLess>;
        else if (!m.isImage && !m.isVideo && m.url)
            mediaDisplay = <p>
                {m.thumbMd
                    ? <a href={m.url} target="_blank" title={m.fileName}><img alt={m.fileName} src={m.thumbMd} style={{ width: "500px" }} /></a>
                    : <a href={m.url}>{m.fileName}</a>}
                </p>;

        const captionField = tm.promptCaption
            ? <>
                <p>Caption</p>

                <Comp.Editors.RichTextField
                    formComponent={this.props.formComponent}
                    name={`${this.props.namePrefix}caption`}
                    noFieldWrap
                    options={TinymceOptions.specialCharacters({
                        height: 150,
                        statusbar: true,
                        wordlimit_max: 75,
                    }, "wordcountsimple wordlimit")}
                />
            </>
            : null;

        const titleField = tm.promptTitle
        ? <>
            <p>Title</p>

            <Comp.Editors.RichTextField
                formComponent={this.props.formComponent}
                name={`${this.props.namePrefix}title`}
                noFieldWrap
                options={TinymceOptions.specialCharacters({
                    height: 150,
                    statusbar: true,
                    wordlimit_max: 150,
                }, "wordcountsimple wordlimit")}
            />
        </>
            : null;

        const keywordsField = tm.promptKeywords
            ? <>
                <p>Keywords</p>

                <Comp.Editors.SelectField
                    formComponent={this.props.formComponent}
                    noFieldWrap
                    isAsync
                    name={`${this.props.namePrefix}tags`}
                    select={{
                        // cache: false,
                        arrowRenderer: () => null,
                        ignoreCase: false,
                        loadOptions: (search: string) => this.searchTags(search),
                        multi: true,
                        optionRenderer: (r: M.Tag.Tag) => <span>{r.name}</span>,
                        placeholder: "Retinablastoma, Macular pucker, etc.",
                        searchPromptText: "Start typing and select from suggested or enter new tags",
                        valueRenderer: (r: M.Tag.Tag) => <span>{r.name}</span>,
                    }}
                />
            </>
            : null;

        return <div className="highlight">
            {mediaDisplay}

            <p>
                <a href="#" onClick={(e) => { ReactHelper.emptyClick(e); this.props.onRemove(); }}>
                    Remove
                </a>
            </p>

            {titleField}
            {captionField}
            {keywordsField}
        </div>;
    }

    private searchTags(search: string) {
        if (!search || search.length < 2)
            return Promise.resolve({ options: [] });

        return new Promise((resolve, reject) => {
            // delay the ajax call as to not make a call for each letter typed.
            if (this._searchTimeout !== undefined)
                clearTimeout(this._searchTimeout);

            this._searchTimeout = setTimeout(() => {
                const queryParams = { queryParams: { search, max: 10 }};

                // for adding new value
                const newTag: M.Tag.Tag & M.Generic.ReactSelectOption =
                    Utility.toReactSelectOption({ id: 0, statusId: 0, name: search }, search, search);

                this.props.api.callApi<M.Tag.Tag[]>(Api.endpoints.tag.tags, queryParams)
                    .then((result) => {
                        if (result.isSuccess && result.data) {
                            let options = result.data.map((tag) => {
                                return Utility.toReactSelectOption(tag, tag.name, tag.id);
                            });

                            const newTagMatch = _.find(options, (tag) => {
                                return tag.name.toLowerCase().trim() === newTag.label.toLowerCase().trim();
                            });

                            if (newTagMatch === undefined)
                                options = [newTag, ...options];

                            options = [...options];
                            resolve({ options });
                        }
                        else
                            console.error(result.errors.join("; "));
                    });
            }, 375);
        }).then((data) => {
            return data;
        });
    }
}



// WEBPACK FOOTER //
// ./src/containers/abstracts/composer/components/AbstractMediaEditor.tsx